import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/service/user.service';
import { RoleService } from 'src/app/service/role.service';
import { OrgService } from 'src/app/service/org.service';
import { CoursesService } from 'src/app/service/courses.service';
import { AcademicsService } from 'src/app/service/academics.service';
import { DatePipe } from '@angular/common'
import { ScoresService } from 'src/app/service/scores.service';
@Component({
  selector: 'app-ass-unit-create',
  templateUrl: './ass-unit-create.component.html',
  styleUrls: ['./ass-unit-create.component.scss']
})
export class AssUnitCreateComponent implements OnInit {
  showLoader: boolean = false;
  creating: boolean = false;
  highlightColors: any = [];

  assessmentUnitCreate = new FormGroup({
    nameAr: new FormControl('', [
      Validators.required,
    ]),
    nameEn: new FormControl('', [
      Validators.required,
    ])

  });

  constructor(
    // private userService: UserService,
      private scoresService: ScoresService,
    private toastrService: ToastrService
    // , private roleService: RoleService
    , public globals: Globals, private toastr: ToastrService, private activatedRoute: ActivatedRoute, private router: Router
    , public translate: TranslateService
    , private academicsService: AcademicsService
    , private roleService: RoleService
    , private orgService: OrgService
    , private datePipe: DatePipe
  ) {

  }

  ngOnInit(): void {
  }

  assessmentUnitCreateChange() {
    // let classHours = this.createType.controls.classHours.value;
    // let clinicalHours = this.createType.controls.clinicalHours.value;
    // this.createType.controls.totalHours.setValue(Number(classHours) + Number(clinicalHours));
  }

  assessmentUnitCreateSubmit() {
    if (this.assessmentUnitCreate.valid) {
      console.log(this.assessmentUnitCreate.value);
      // call your service 
       let nameAr = this.assessmentUnitCreate.controls.nameAr.value;
       let nameEn = this.assessmentUnitCreate.controls.nameEn.value;
      this.addAssessmentUnit( nameAr, nameEn)
    }
    else {
      this.assessmentUnitCreate.markAllAsTouched();
      this.assessmentUnitCreate.markAsDirty();
    }
  }

  addAssessmentUnit(nameAr: string, nameEn: string) {
     this.creating = true;
     let username = this.globals.currentUserInfo.username;
     this.scoresService.addِِِAssesmentUnit(username, 10, nameAr, nameEn)
       .subscribe(
         data => {
           console.log(data);
           if (data.sts == "SUCCESS") {
            if (this.globals.lang == "ar") {
              this.toastrService.success(data.arMsg);
            } else {
              this.toastrService.success(data.enMsg);
            }
             this.creating = false;
             this.router.navigate(['/scores-grades/assessment-units']);
           } else {
            if (this.globals.lang == "ar") {
              this.toastrService.error(data.arMsg);
            } else {
              this.toastrService.error(data.enMsg);
            }
            this.creating = false;
            //this.router.navigate(['/academics/calender-day-type']);
          } 
         },
         error => {
           this.creating = false;
           this.toastrService.error(this.translate.instant('FAIL_TO_CREATE'));
         }
       );
  }




  onItemSelect(item: any) {
    // console.log('onItemSelect', item);
  }

  changeactive() {

  }

}


